// src/app/api/baseApi.ts
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL || "http://localhost:8000/api",
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as any).auth.token;
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    api.dispatch({ type: "auth/logout" });
  }
  return result;
};

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    // ── Existing ──────────────────────────────
    "User",
    "Region",
    // ── GIMLP ────────────────────────────────
    "ProgrammeCycle", // programme.js
    "LibraryContent", // library.js
    "Task", // tasks.js — task definitions
    "TaskSubmission", // tasks.js — mentee submissions
    "JourneyProfile", // journey.js — MenteeProfile
    "JourneyActivity", // journey.js — MenteeActivity log
    "JourneyQuarters", // journey.js — per-quarter breakdown
    "Fellows", // fellows.js — published reports
    "FellowsStatus", // fellows.js — my-status / eligibility
    "FellowsNominations", // fellows.js — admin nominations list
    "Announcement", // community.js
    "Discussion", // community.js — posts
    "DiscussionReplies", // community.js — replies per post
    "RegionalUpdate", // community.js
    "Directory", // community.js — member directory
    "VideoProgress",
    "JourneyActivity",
    "JourneyQuarters",
    "JourneyProfile",
    "EventRegs",
    "Event",
    "Province",
    "MentorAssignment",
    "Mentor",
  ],
  endpoints: () => ({}),
});
